export default __webpack_public_path__ + "static/media/Content2.5dedab8c.png";